module.exports = __webpack_public_path__ + "static/img/7.87c84d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/zh/7.png
// module id = z5fA
// module chunks = 0